
















import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import TextBox from '@/views/atoms/TextBox.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'

export default
  components: {
    Popup
    BlueButton
    TextBox
    ErrorLabel
  }

  props:
    title:
      type: String
      default: ''
    id:
      type: String
      default: ''
    apiUrl:
      type: String
      default: ''
    isPartner:
      type: Boolean
      default: false
  
  created: () ->
    store.dispatch('setErrors', [])
  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_click: () ->
      api = new ApiClient()
      param = 
        id: @id
        password: store.getters.getPostParam['password']
      if !@isPartner
        data = await api.post('/fc/'+ @apiUrl + '/change_password', param)
      else
        data = await api.post('/partner/tanto/change_password', param)
      if data.errors.length == 0
        @$emit('click')
  }
